"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var moment = require("moment");
var DATE_FORMAT = 'DD.MM.YYYY';
function calculatePorts(ports, journey) {
    var startDate = journey.departure;
    var endDate = journey.arrival;
    var duration = calculateDuration(startDate, endDate);
    // Generates a list of cruise dates from start until inclusively
    // the last cruise day.
    var days = lodash_1.map(lodash_1.range(0, duration + 1), function (day) {
        var momentStart = moment.utc(startDate, DATE_FORMAT);
        momentStart.add(day, 'days');
        return momentStart.format(DATE_FORMAT);
    });
    // Assigns journey segments to each day.
    // Each day may be zero or more journey segments.
    // Zero journey segments means it is a passage day.
    // Every journey element translates to one port visit.
    // Example structure: [[Segment], [], [Segment, Segment], [Segment]]
    var daySegmentJourney = lodash_1.map(days, function (day) {
        return lodash_1.filter(journey.segments, function (journeySegment) {
            return moment
                .utc(day, DATE_FORMAT)
                .isBetween(moment.utc(journeySegment.arrivalDate, DATE_FORMAT), moment.utc(journeySegment.departureDate, DATE_FORMAT), 'day', '[]');
        });
    });
    // Translates every day into a passage day or a list of ports.
    // Example structure: [[PortA], [Sea], [PortB,PortC], [PortC]]
    var daysPorts = lodash_1.map(daySegmentJourney, function (journeyDataSegments, index) {
        // date
        var day = days[index];
        // A day with zero segments means a passage day
        if (journeyDataSegments.length === 0) {
            return [
                {
                    name: 'SEE',
                    arrivalTime: undefined,
                    departureTime: undefined,
                    code: 'SEE',
                    coordinates: undefined,
                    countryCode: 'XX',
                    date: day,
                    portOfArrival: undefined,
                    portOfDeparture: undefined,
                    unloCode: 'XXSEE',
                },
            ];
        }
        // Map journey to port
        return lodash_1.map(journeyDataSegments, function (segment) {
            var port = lodash_1.find(ports, ['id', segment.portID]);
            var arrivalTime;
            var departureTime;
            if (day === segment.arrivalDate) {
                arrivalTime = segment.arrivalTime;
            }
            if (day === segment.departureDate) {
                departureTime = segment.departureTime;
            }
            var p = {
                name: port.name,
                arrivalTime: arrivalTime,
                departureTime: departureTime,
                code: port.id,
                // coordinates: port.coordinates,
                countryCode: port.countryID,
                date: day,
                portOfArrival: lodash_1.find(ports, ['id', lodash_1.last(journey.segments).portID]) !== undefined,
                portOfDeparture: lodash_1.find(ports, ['id', lodash_1.head(journey.segments).portID]) !== undefined,
                unloCode: port.id,
            };
            return p;
        });
    });
    return lodash_1.flatten(daysPorts);
}
function sortedCountries(countries) {
    var sorted = lodash_1.sortBy(countries, ['name']);
    var ger = lodash_1.find(countries, function (country) {
        return country.id === 'DE';
    });
    var at = lodash_1.find(countries, function (country) {
        return country.id === 'AT';
    });
    var ch = lodash_1.find(countries, function (country) {
        return country.id === 'CH';
    });
    var filtered = lodash_1.reject(sorted, function (country) {
        return country.id === 'DE' || country.id === 'AT' || country.id === 'CH';
    });
    return lodash_1.concat([ger, at, ch], filtered);
}
function convertBookingResponse(cruiseResponse, countriesResponse, formValidationsResponse) {
    // const pricMod = priceModel
    var mandatoryFlight = {
        PREMIUMAI: cruiseResponse.mandatoryFlight['PREMIUMAI']
            ? cruiseResponse.mandatoryFlight['PREMIUMAI']
            : false,
        PREMIUM: cruiseResponse.mandatoryFlight['PREMIUM']
            ? cruiseResponse.mandatoryFlight['PREMIUM']
            : false,
        VARIO: cruiseResponse.mandatoryFlight['VARIO']
            ? cruiseResponse.mandatoryFlight['VARIO']
            : false,
        UK: false,
        MIT: false,
        ANG: false,
        PEP: false,
        PEPEX: false,
        FUP: false,
        JUST: cruiseResponse.mandatoryFlight['JUST']
            ? cruiseResponse.mandatoryFlight['JUST']
            : false,
        SEETOURS: cruiseResponse.mandatoryFlight['SEETOURS']
            ? cruiseResponse.mandatoryFlight['SEETOURS']
            : false,
        PAUSCHAL: cruiseResponse.mandatoryFlight['PAUSCHAL']
            ? cruiseResponse.mandatoryFlight['PAUSCHAL']
            : false,
    };
    var json = {
        sexes: {
            M: 'Herr',
            F: 'Frau',
        },
        formValidations: lodash_1.groupBy(formValidationsResponse, 'field'),
        countries: lodash_1.reduce(sortedCountries(countriesResponse), function (result, country) {
            result[country.id] = {
                isoCode: country.id,
                name: country.name,
                phone: country.internationalAreaCode,
            };
            return result;
        }, {}),
        paymentCountries: lodash_1.map(sortedCountries(lodash_1.filter(countriesResponse, ['paymentCountry', true])), function (paymentCountry) {
            return {
                isoCode: paymentCountry.id,
                zipFormat: paymentCountry.zipFormat,
                zipPrefix: paymentCountry.zipPrefix,
                name: paymentCountry.name,
            };
        }),
        cruise: mapCruiseResponse(cruiseResponse, mandatoryFlight),
    };
    return json;
}
exports.convertBookingResponse = convertBookingResponse;
function mapCruiseResponse(cruiseResponse, mandatoryFlight) {
    var lastSegment = lodash_1.last(cruiseResponse.journeys[0].segments);
    var lastPortID = lastSegment ? lastSegment.portID : undefined;
    var arrivalStation = lastPortID
        ? lodash_1.find(cruiseResponse.ports, ['id', lastPortID])
        : undefined;
    var arrivalStationName = arrivalStation ? arrivalStation.name : undefined;
    var firstSegment = lodash_1.head(cruiseResponse.journeys[0].segments);
    var firstPortID = firstSegment ? firstSegment.portID : undefined;
    var departureStation = firstPortID
        ? lodash_1.find(cruiseResponse.ports, ['id', firstPortID])
        : undefined;
    var departureStationName = departureStation
        ? departureStation.name
        : undefined;
    /* if (priceModel === 'JUST') {
      return {
        arrival: cruiseResponse.endDate,
        arrivalGermany: cruiseResponse.germanArrival,
        arrivalStationName: '',
        cruiseId: cruiseResponse.id,
        departure: cruiseResponse.startDate,
        departureGermany: cruiseResponse.germanDeparture,
        departureStationName: '',
        shipCode: cruiseResponse.ships[0].id,
        routeCode: cruiseResponse.itinerary[0].id,
        shipName: cruiseResponse.ships[0].name,
        mandatoryFlight: mandatoryFlight,
        region: cruiseResponse.region[0].name,
        ports: [],
        duration: cruiseResponse.duration,
        amenityPrice: sumBy(
          get(cruiseResponse, 'cabinCategories[0].amenities', []),
          'amount'
        ),
        name: '',
        description: '',
        shipImage: cruiseResponse.ships[0].teaserImage.file,
        shipDetachedImage: cruiseResponse.ships[0].detachedImage.file,
        routeMap: cruiseResponse.itinerary[0].mapImageUrl,
        minPaxAge: cruiseResponse && cruiseResponse.minPaxAge ? cruiseResponse.minPaxAge : 0,
        realCruises: map<Journey, ObsoleteRealCruiseDescription>(
          cruiseResponse.journeys,
          journey => {
            const itin = find(cruiseResponse.itinerary, [
              'id',
              journey.itineraryID,
            ])
            const ship = find(cruiseResponse.ships, ['id', journey.shipID])
            const region = find(cruiseResponse.region, ['id', journey.regionID])
  
            return {
              arrival: journey.arrival,
              arrivalGermany: cruiseResponse.germanArrival,
              arrivalStationName: arrivalStationName,
              cruiseId: journey.cruiseID,
              departure: journey.departure,
              departureGermany: cruiseResponse.germanDeparture,
              departureStationName: departureStationName,
              shipCode: journey.shipID,
              routeCode: journey.itineraryID,
              shipName: ship ? ship.name : undefined,
              mandatoryFlight,
              region: region ? region.name : undefined,
              ports: calculatePorts(cruiseResponse.ports, journey),
              duration: calculateDuration(journey.departure, journey.arrival),
              name: itin ? itin.name : undefined,
              description: itin ? itin.description : undefined,
              shipImage: ship.teaserImage.file,
              shipDetachedImage: ship.detachedImage.file,
              routeMap: itin ? itin.mapImageUrl : undefined,
              seasonCd: journey.seasonID,
              minPaxAge: cruiseResponse && cruiseResponse.minPaxAge ? cruiseResponse.minPaxAge : 0
            }
          }
        ),
        seasonCd: cruiseResponse.season,
      }
    }
    */
    return {
        arrival: cruiseResponse.endDate,
        arrivalGermany: cruiseResponse.germanArrival,
        arrivalStationName: arrivalStationName,
        cruiseId: cruiseResponse.id,
        departure: cruiseResponse.startDate,
        departureGermany: cruiseResponse.germanDeparture,
        departureStationName: departureStationName,
        shipCode: lodash_1.get(cruiseResponse, 'ships[0].id', undefined),
        routeCode: lodash_1.get(cruiseResponse, 'itinerary[0].id', undefined),
        shipName: lodash_1.get(cruiseResponse, 'ships[0].name', undefined),
        configCode: lodash_1.get(cruiseResponse, 'ships[0].configCode', undefined),
        mandatoryFlight: mandatoryFlight,
        region: lodash_1.get(cruiseResponse, 'region[0].name', undefined),
        ports: calculatePorts(cruiseResponse.ports, cruiseResponse.journeys[0]),
        duration: cruiseResponse.duration,
        amenityPrice: lodash_1.sumBy(lodash_1.get(cruiseResponse, 'cabinCategories[0].amenities', []), 'amount'),
        name: lodash_1.get(cruiseResponse, 'itinerary[0].name', undefined),
        description: lodash_1.get(cruiseResponse, 'itinerary[0].description', undefined),
        shipImage: lodash_1.get(cruiseResponse, 'ships[0].teaserImage.file', undefined),
        shipDetachedImage: lodash_1.get(cruiseResponse, 'ships[0].detachedImage.file', undefined),
        routeMap: lodash_1.get(cruiseResponse, 'itinerary[0].mapImageUrl', undefined),
        seasonCd: cruiseResponse ? cruiseResponse.season : undefined,
        minPaxAge: cruiseResponse && cruiseResponse.minPaxAge ? cruiseResponse.minPaxAge : 0
    };
}
function calculateDuration(start, end) {
    var startDate = moment(start, DATE_FORMAT);
    var endDate = moment(end, DATE_FORMAT);
    return endDate.diff(startDate, 'days');
}
//# sourceMappingURL=mapBookingResponse.js.map